export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1755_.632bb5ca.jpg";